<template>
  <footer class="pw-footer">
    <div class="container pw-footer-inner">
      <div class="pw-footer-left">
        <p class="pw-footer-brand">
          Prado's Desenvolvimento Web
          <span class="pw-footer-pill">Portfólio</span>
        </p>
        <p class="pw-footer-text">
          Desenvolvimento de sites, sistemas web e integrações sob medida
          para empresas e profissionais.
        </p>
        <p class="pw-footer-copy">
          © {{ year }} · Todos os direitos reservados.
        </p>
      </div>

      <div class="pw-footer-right">
        <p class="pw-footer-label">Conecte-se</p>
        <div class="pw-footer-links">
          <a
            href="https://github.com/LeandroVPrado"
            target="_blank"
            rel="noopener"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/leandro-vinicius-do-prado"
            target="_blank"
            rel="noopener"
          >
            LinkedIn
          </a>
          <a href="mailto:contato@pradosweb.com.br">
            E-mail
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.pw-footer {
  border-top: 1px solid rgba(148, 163, 184, 0.25);
  background: radial-gradient(circle at top, rgba(15, 23, 42, 0.95), #020617);
  padding: 1.8rem 0 1.9rem;
}

.pw-footer-inner {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  align-items: flex-start;
}

.pw-footer-left {
  max-width: 420px;
}

.pw-footer-brand {
  font-weight: 500;
  margin: 0 0 0.4rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.pw-footer-pill {
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: linear-gradient(
    to right,
    rgba(34, 211, 238, 0.08),
    rgba(139, 92, 246, 0.2)
  );
}

.pw-footer-text {
  margin: 0 0 0.35rem;
  font-size: 0.85rem;
  color: rgba(148, 163, 184, 0.9);
}

.pw-footer-copy {
  margin: 0;
  font-size: 0.75rem;
  color: rgba(148, 163, 184, 0.75);
}

.pw-footer-right {
  text-align: right;
}

.pw-footer-label {
  margin: 0 0 0.4rem;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: rgba(209, 213, 219, 0.8);
}

.pw-footer-links {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.pw-footer-links a {
  font-size: 0.85rem;
  color: rgba(209, 213, 219, 0.9);
  text-decoration: none;
  position: relative;
  padding-bottom: 0.05rem;
}

.pw-footer-links a::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 0;
  height: 1px;
  background: linear-gradient(to right, #22d3ee, #8b5cf6);
  transition: width 0.2s ease-out;
}

.pw-footer-links a:hover::after {
  width: 100%;
}

/* Responsivo */
@media (max-width: 768px) {
  .pw-footer-inner {
    flex-direction: column;
  }

  .pw-footer-right {
    text-align: left;
  }

  .pw-footer {
    padding-bottom: 2.5rem;
  }
}
</style>
